import CloudUploadRoundedIcon from '@mui/icons-material/CloudUploadRounded';
import { Button } from '@mui/material';
import { useHistory } from 'react-router-dom';

export const AdjuntarDocumentacion = ({ autorizacion, ...props }) => {
  const history = useHistory();

  return (
    <Button
      variant='contained'
      onClick={() => history.push('/adjuntar-documentacion', { autorizacion })}
      color='warning'
      disableElevation
      startIcon={<CloudUploadRoundedIcon />}
    >
      Adjuntar Documentación
    </Button>
  );
};
